import { Component, Input } from '@angular/core';

export type HxIconName =
  | 'cloud'
  | 'card'
  | 'grid'
  | 'integration'
  | 'shield'
  | 'support'
  | 'bank'
  | 'document'
  | 'check-shield'
  | 'mobile'
  | 'ledger'
  | 'transfer';

/**
 * Single reusable icon component covering the brand's inline SVG set
 * (24x24 viewBox, stroke-based, inherits currentColor via .card-icon).
 * For a broader icon library, @angular/material/icon (MatIconModule) is
 * also installed and can be used with the Material Icons font or SVG
 * registry if you want to swap any of these for a standard icon set.
 *
 *   <hx-icon name="cloud"></hx-icon>
 */
@Component({
  selector: 'hx-icon',
  standalone: true,
  template: `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
      @switch (name) {
        @case ('cloud') {
          <path d="M6 18a4 4 0 0 1-1-7.9A5 5 0 0 1 14 7a4.5 4.5 0 0 1 2 8.5" />
          <path d="M6 18h11" />
        }
        @case ('card') {
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="M3 10h18M7 15h4" />
        }
        @case ('grid') {
          <rect x="4" y="4" width="7" height="7" rx="1" />
          <rect x="13" y="4" width="7" height="7" rx="1" />
          <rect x="4" y="13" width="7" height="7" rx="1" />
          <rect x="13" y="13" width="7" height="7" rx="1" />
        }
        @case ('integration') {
          <path d="M4 12a8 8 0 0 1 14.5-4.6M20 12a8 8 0 0 1-14.5 4.6" />
          <path d="M15 4v4h4M9 20v-4H5" />
        }
        @case ('shield') {
          <path d="M12 22s8-4.5 8-11V5l-8-3-8 3v6c0 6.5 8 11 8 11Z" />
        }
        @case ('support') {
          <path d="M4 19V9M12 19V5M20 19v-7" />
        }
        @case ('bank') {
          <path d="M3 10 12 4l9 6" />
          <path d="M5 10v9M19 10v9M9 10v9M15 10v9" />
          <path d="M3 21h18" />
        }
        @case ('document') {
          <path d="M7 3h8l4 4v14H7z" />
          <path d="M15 3v4h4M9 12h6M9 16h6" />
        }
        @case ('check-shield') {
          <path d="M9 12l2 2 4-4" />
          <circle cx="12" cy="12" r="9" />
        }
        @case ('mobile') {
          <rect x="7" y="2" width="10" height="20" rx="2" />
          <path d="M11 18h2" />
        }
        @case ('ledger') {
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <path d="M3 9h18M8 4v5" />
        }
        @case ('transfer') {
          <path d="M17 2l4 4-4 4M21 6H9M7 22l-4-4 4-4M3 18h12" />
        }
      }
    </svg>
  `,
})
export class IconComponent {
  @Input({ required: true }) name!: HxIconName;
}
